import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./Components/Global/AuthProvider.js"
import { Provider } from "react-redux"
import { store, Persistor } from "./Components/Global/store"
import { PersistGate } from 'redux-persist/integration/react'
// import { store } from "./Components/Global/store"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Provider store={store}>
  <AuthProvider>
  <PersistGate loading={null} persistor={Persistor}>
  <App />
  </PersistGate>
  </AuthProvider>
  </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
